import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserSubscription } from '../../utilities/interfaces/UserSubscription';
import { userSubscriptionAPI } from '../../utilities/api';

// represents the shape of the slice in state
interface UserSubscriptionState {
  userSubscription: UserSubscription[];
  userSubscriptionTableData: any[];
  fetchingUserSubscription: boolean;
}

const initialState: UserSubscriptionState = {
  userSubscription: [],
  userSubscriptionTableData: [],
  fetchingUserSubscription: false,
};

const userSubscriptionSlice = createSlice({
  name: 'publicUserSubscription',
  initialState,
  reducers: {
    // add new cms item
    addUserSubscription(state, action: PayloadAction<any>) {
      // its okay to do this because immer makes it immutable
      state.userSubscription?.push(action.payload);
    },
    removeUserChapterSubscription(state, action: PayloadAction<any>){
      state.userSubscription = state.userSubscription.filter(x => x.chapterId !== action.payload.chapterId);
    },
    removeUserTitleSubscription(state, action: PayloadAction<any>){
      state.userSubscription = state.userSubscription.filter(x => x.titleId !== action.payload.titleId);
    },
    removeUserAgencySubscription(state, action: PayloadAction<any>) {
      state.userSubscription = state.userSubscription.filter(x => x.agencyId !== action.payload.agencyId);
    },
    setUserSubscriptionTableData(state, action: PayloadAction<any>){
      state.userSubscriptionTableData = action.payload;
    },
    clearUserSubscriptionTableData(state) {
      state.userSubscriptionTableData = [];
    }
  },
  extraReducers(builder) {
    builder.addCase(getUserSubscriptionByEmail.pending, (state) => {
      state.fetchingUserSubscription = true;
    })
    builder.addCase(getUserSubscriptionByEmail.fulfilled, (state, action: any) => {
      state.userSubscription = action.payload;
      state.fetchingUserSubscription = false;
    });
    builder.addCase(getUserSubscriptionByEmail.rejected, (state) => {
      state.fetchingUserSubscription = false;
    });
    builder.addCase(deleteUserSubscription.fulfilled, (state, action: any) => {
      state.userSubscription = state.userSubscription.filter(x => x.id !== action.meta.arg.id);
      state.userSubscriptionTableData = state.userSubscriptionTableData.filter(x => x.id !== action.meta.arg.id);
    });
    builder.addCase(deleteAllUserSubscription.fulfilled, (state) => {
      state.userSubscription = [];
      state.userSubscriptionTableData = [];
    });
  },
});

// Thunks for any async data dealing with the api
export const getUserSubscriptionByEmail = createAsyncThunk(
  'userSubscription/getUserSubscriptions',
  async (email: string) => {
    return await userSubscriptionAPI.getUserSubscriptions(email);
  }
);

export const deleteUserSubscription = createAsyncThunk(
    'UserSubscription',
    async  (subscriptionToDelete: any) => {
      const subscription: UserSubscription = {
        id: subscriptionToDelete.id,
        subscriptionUserId: subscriptionToDelete.subscriptionUserId,
        agencyId: subscriptionToDelete.agencyId!,
        titleId: subscriptionToDelete.titleId!,
        chapterId: subscriptionToDelete.chapterId!,
      };

      return await userSubscriptionAPI.removeUserSubscription(subscription);
    }
);

export const deleteAllUserSubscription = createAsyncThunk(
    'UserSubscription/Range',
    async  (subscriptionsToDelete: any[]) => {
      const subscriptions: UserSubscription[] = [];

      // eslint-disable-next-line array-callback-return
      subscriptionsToDelete.map((subscriptionToDelete: any) => {
        const subscription: UserSubscription = {
          id: subscriptionToDelete.id,
          subscriptionUserId: subscriptionToDelete.subscriptionUserId,
          agencyId: subscriptionToDelete.agencyId!,
          titleId: subscriptionToDelete.titleId!,
          chapterId: subscriptionToDelete.chapterId!,
        };

        subscriptions.push(subscription);
      })

      return await userSubscriptionAPI.removeAllUserSubscriptions(subscriptions);
    }
);


export const { addUserSubscription, removeUserAgencySubscription, removeUserChapterSubscription, removeUserTitleSubscription, setUserSubscriptionTableData, clearUserSubscriptionTableData } = userSubscriptionSlice.actions;
export default userSubscriptionSlice.reducer;
